module.exports = __webpack_public_path__ + "static/media/current_cycle_right.bf19ed14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/current_cycle_right.svg
// module id = 104
// module chunks = 0